export default "__VITE_ASSET__50a8175c__"